<root-tag>
  <loading di-register-name="loader"></loading>
  <div is="{tag}"></div>

  <script>
    import di from 'dependeny-injection'
    import inquiry from './contents/inquiry.riot'
    import confirmInquiry from './contents/confirm-inquiry.riot'
    import executeInquiry from './contents/execute-inquiry.riot'

    export default {
      tag: 'inquiry',
      components: {
        'inquiry'       : inquiry,
        'confirm'       : confirmInquiry,
        'execute'       : executeInquiry
      },
      onBeforeMount(props, state) {
        di.inquiry.setChanger((tag)=>{
          this.tag = tag;
          this.update();
        });
      }
    }
  </script>
  <style>
    :host {
      height: 100%;
      width: 100%;
    }
  </style>
</root-tag>